import { Component, OnInit } from '@angular/core';
import { ReporteService } from '@app/core/service/reporte.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoryService, ProductService, UserService } from '@app/core';
import { Category } from '@core/model/category.model';
import { Product } from '@core/model/product.model';
import { User } from '@app/core/model/user.model';
import { ClientService } from '@app/core/service/client.service';
import { Client } from '@app/core/model/client.model';

@Component({
  selector: 'app-cobranzas',
  templateUrl: './cobranzas.component.html',
  styleUrls: ['./cobranzas.component.css']
})
export class CobranzasComponent implements OnInit {
  inicio: string;
  final: string;
  existencia: any;
  buscarForm: FormGroup;
  categories: Category[];
  products: Product[];
  ventas: any;
  isLoading = false;
  users: User[];
  todos: number;

  selectedValue: any;
  nit: string;
  direccion: string;
  clientes: Client[];

  totalSum = 0;
  totalPagado = 0;
  totalDeuda = 0;
  constructor(
    private reporteService: ReporteService,
    private categoryService: CategoryService,
    private clienteService: ClientService,
    private userService: UserService,
    private productoService: ProductService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.createForm();
    this.listData2();
    // this.ListarExistencia();
    this.listVendedores();
    this.listarClientes();
  }

  createForm() {
    this.buscarForm = this.formBuilder.group({
      inicio: [
        new Date().toISOString().substring(0, 10),
        [Validators.required]
      ],
      fin: [new Date().toISOString().substring(0, 10), [Validators.required]],

      vendedor: ['', [Validators.nullValidator]],
      producto: ['', [Validators.nullValidator]],
      cliente_id: '',
      user_id: ''
      /*   categoria: ['',[Validators.required]],
         producto:['',[Validators.required]]*/
    });
  }
  getSelectedProduct(event: Product) {
    // alert(event);

    console.log('Producto Changed: ' + event.producto_id);
    // console.log(JSON.stringify(event));
    // this.resetPurchase();
    // this.showDiv = null;
    // console.log(i);
    this.todos = event.producto_id;
    //  this.patchValues(event.producto_id, i);
    // this.addressCustomer = event.address;
  }
  listVendedores() {
    this.userService.getAllVendedores().subscribe(
      data => {
        this.users = data;
        console.log(data);
      },
      error => {
        console.log(error.error);
      }
    );
  }

  listData2() {
    // listando cattegorias

    // listtando producto
    const fechaActual = new Date();
    const dia = fechaActual.getDate().toString();
    const mes = (fechaActual.getMonth() + 1).toString();
    const anio = fechaActual.getFullYear().toString();
    const data2 = {
      fecha_inicio: anio + '/' + mes + '/' + dia,
      fecha_fin: anio + '/' + mes + '/' + dia,
      user_id: 0,
      cliente_id: 0
    };

    this.reporteService.reporteCobranzas(data2).subscribe(
      data => {
        console.log(data);
        this.ventas = data;

        this.totalSum = this.calculateTotal();
        this.totalPagado = this.calculatePagado();
        this.totalDeuda = this.calculateDeuda();
      },
      error => {
        console.log(error);
      }
    );
  }

  listarClientes() {
    this.clienteService.getClientesHabilitados().subscribe(
      data => {
        this.clientes = data;
        this.selectedValue = data[0];

        console.log(this.selectedValue.cliente_id + '2');
      },
      error => {
        console.log(error.error);
      }
    );
  }
  listData() {
    // listando cattegorias
    const fechaActual = new Date();
    const dia = fechaActual.getDate().toString();
    const mes = (fechaActual.getMonth() + 1).toString();
    const anio = fechaActual.getFullYear().toString();
    const data2 = {
      fecha_inicio: anio + '/' + mes + '/' + dia,
      fecha_final: anio + '/' + mes + '/' + dia,
      categoria_id: 0
    };
    // listtando producto
    this.reporteService.productosPedidos(data2).subscribe(
      data => {
        console.log(data);
        this.existencia = data;

        //  this.products = data;
      },
      error => {
        console.log(error);
      }
    );
  }

  public calculateTotal() {
    return this.ventas.reduce(
      (accum: any, curr: any) => accum + Number(curr.total),
      0
    );
  }
  public calculatePagado() {
    return this.ventas.reduce((accum: any, curr: any) => accum + curr.monto, 0);
  }
  public calculateDeuda() {
    return this.ventas.reduce((accum: any, curr: any) => accum + curr.deuda, 0);
  }
  buscarCobranzas() {
    let data = {};

    if (this.todos !== undefined) {
      data = {
        user_id: this.buscarForm.value.user_id,
        cliente_id: this.buscarForm.value.cliente_id,
        fecha_inicio: this.buscarForm.value.inicio,
        fecha_fin: this.buscarForm.value.fin
      };
    } else {
      data = {
        fecha_inicio: this.buscarForm.value.inicio,
        fecha_fin: this.buscarForm.value.fin,
        user_id: this.buscarForm.value.user_id,
        cliente_id: this.buscarForm.value.cliente_id
      };
    }

    console.log(data);

    this.reporteService.reporteCobranzas(data).subscribe(
      data2 => {
        // console.log(data2);
        this.ventas = data2;
        this.totalSum = this.calculateTotal();
        this.totalPagado = this.calculatePagado();
        this.totalDeuda = this.calculateDeuda();
      },
      error1 => {
        console.log(error1);
      }
    );
  }

  ListarExistencia() {
    /* const data = {
       fecha_inicio: '2019/11/02',
       fecha_final: '2019/12/02'
     };*/
    const fechaActual = new Date();
    const dia = fechaActual.getDate().toString();
    const mes = (fechaActual.getMonth() + 1).toString();
    const anio = fechaActual.getFullYear().toString();
    // alert(mes);
    const data = {
      fecha_inicio: anio + '/' + mes + '/' + dia,
      fecha_final: anio + '/' + mes + '/' + dia,
      categoria_id: 0
    };
    console.log(data);
    // alert(this.i/**/nicio);
    this.reporteService.productosPedidos(data).subscribe(
      data2 => {
        //    console.log(data2);
        this.existencia = data2;
      },
      error1 => {
        console.log(error1);
      }
    );
  }

  buscarExistencia2() {
    let data = {};
    console.log(this.todos);
    if (this.todos !== undefined) {
      data = {
        producto_id: this.buscarForm.value.producto,
        categoria_id: this.buscarForm.value.categoria,
        fecha_inicio: this.buscarForm.value.inicio,
        fecha_final: this.buscarForm.value.fin
      };
    }

    console.log(data);
    this.reporteService.existencia(data).subscribe(
      data2 => {
        //  console.log(data2);
        this.existencia = data2;
      },
      error1 => {
        console.log(error1);
      }
    );
  }

  checkStatus(stock: Number, lim: Number) {
    if (stock <= lim) {
      return false;
    } else {
      return true;
    }
  }
}
